module.exports = __webpack_public_path__ + "static/media/connect-wallet.f412380e.svg";